<template lang="pug">
div
  v-card.pa-6.mt-4.round-xl(outlined)
    sharing-qr-code
</template>

<script>
import SharingQrCode from '@/components/review/settings/SharingQrCode.vue'

export default {
  name: 'SharingTab',
  components: {
    SharingQrCode,
  },
}
</script>

<style scoped>
</style>